import { VEHICLE_SOURCE_NEEDS_REVIEW_FILTER } from "../../../../constants/vehicleSourceConstants";

const APPROVED_REVIEW = new Set(["APPROVED", "APPROVED_WITH_LIMITS"]);
const PENDING_REVIEW = new Set(["NOT_REVIEWED", "REVIEW_PENDING", "UNKNOWN", ""]);

export function sourceNeedsReview(source) {
  if (!source) return false;
  if (source.sourceStatus === "REVIEW_PENDING" || source.sourceStatus === "DISCOVERED") {
    return true;
  }
  return [source.robotsReviewStatus, source.termsReviewStatus, source.accessReviewStatus].some(
    (status) => PENDING_REVIEW.has(status || "")
  );
}

export function complianceProgress(source) {
  const checks = [
    { key: "robots", label: "Robots", status: source.robotsReviewStatus },
    { key: "terms", label: "Terms", status: source.termsReviewStatus },
    { key: "access", label: "Access", status: source.accessReviewStatus },
  ];
  const approved = checks.filter((c) => APPROVED_REVIEW.has(c.status)).length;
  return { checks, approved, total: checks.length };
}

export function sourceStatusTone(status) {
  if (status === "APPROVED" || status === "ACTIVE") return "success";
  if (status === "BLOCKED" || status === "DEPRECATED") return "danger";
  if (status === "DISCOVERED" || status === "REVIEW_PENDING") return "warn";
  return "neutral";
}

export const REVIEW_QUICK_FILTERS = [
  { id: "queue", label: "Review queue", value: VEHICLE_SOURCE_NEEDS_REVIEW_FILTER },
  { id: "discovered", label: "Discovered", value: "DISCOVERED" },
  { id: "approved", label: "Approved", value: "APPROVED" },
  { id: "all", label: "All sources", value: "" },
];
